import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import CustomCursor from "@/components/CustomCursor";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Portfolio from "@/components/Portfolio";
import Pricing from "@/components/Pricing";
import Products from "@/components/Products";
import Contact from "@/components/Contact";
import MapInstagram from "@/components/MapInstagram";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import useScrollReveal from "@/hooks/useScrollReveal";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Space from "@/components/Space";
import CookieBanner from "@/components/CookieBanner";
import Privacy from "@/pages/Privacy";
import LocationPage from "@/pages/LocationPage";
import {
    SESTAO_DATA,
    BARAKALDO_DATA,
    PORTUGALETE_DATA,
    BILBAO_DATA,
} from "@/lib/locationData";

function PublicSite() {
    useScrollReveal();
    return (
        <>
            <CustomCursor />
            <Navbar />
            <main>
                <Hero />
                <About />
                <Portfolio />
                <Pricing />
                <Products />
                <Space />
                <Contact />
                <MapInstagram />
            </main>
            <Footer />
            <FloatingWhatsApp />
            <CookieBanner />
        </>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/privacidad" element={<Privacy />} />
                    <Route
                        path="/fotografia-bodas-bilbao"
                        element={<LocationPage city="Bilbao" data={BILBAO_DATA} />}
                    />
                    <Route
                        path="/fotografia-bodas-sestao"
                        element={<LocationPage city="Sestao" data={SESTAO_DATA} />}
                    />
                    <Route
                        path="/fotografia-bodas-barakaldo"
                        element={<LocationPage city="Barakaldo" data={BARAKALDO_DATA} />}
                    />
                    <Route
                        path="/fotografia-bodas-portugalete"
                        element={<LocationPage city="Portugalete" data={PORTUGALETE_DATA} />}
                    />
                    <Route path="*" element={<PublicSite />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-center"
                toastOptions={{
                    style: {
                        background: "#1C1A18",
                        color: "#FAFAF8",
                        border: "1px solid #C4A882",
                        borderRadius: 0,
                        fontFamily: "Jost, sans-serif",
                        fontWeight: 300,
                        letterSpacing: "0.04em",
                    },
                }}
            />
        </div>
    );
}

export default App;
